import 'materialize-css'
import MainRoutes from './Routes';
import {UserProvider} from './UserContext';
import { Toaster } from 'react-hot-toast';


function App(){
  	return (
		<UserProvider>
			<Toaster position="top-right" toastOptions={{ style: { zIndex: 9999 } }} />
			<MainRoutes />
		</UserProvider>
	);
}

export default App;
